/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { all_routes } from "../../../Router/all_routes";
// import { Filter, Sliders } from "react-feather";
import { useNavigate } from "react-router-dom";
// import Select from "react-select";
import { Edit, Trash2,PlusCircle } from "react-feather";
import { Table } from "antd";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import {set_store_edit} from "../../../core/redux/action";

// import ImageWithBasePath from "../../img/imagewithbasebath";
// import Breadcrumbs from "../../../core/breadcrumbs";
//import StoreModal from "../../../feature-module/settingPages/storeModal";
import { APIgetStores, APIDeleteStore } from "../../../api/settings.ts";

const StoreList = () => {
  const translation = useSelector(state => state.root.translation);
  const [loading, setLoading] = useState(true);
  const l = useSelector((state) => state.language || "en");
  const t = useSelector((state) => state.translation || "en");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [dataStore, setDataStore] = useState([])
  // const [editStore, setEditStore] = useState({})
  // const [ setEditStore] = useState({})
  useEffect(() => {
    getStoreApi();
  }, []);
  //Permissions  
  const permissions = useSelector(state => state.root.permissions) || [];
  const roleTitle = useSelector(state => state.root.roleTitle) || '';
  const roleTitleAdmin = useSelector(state => state.root.roleTitleAdmin) || '';

  const canView = roleTitle === roleTitleAdmin || permissions.some(p => p.Module.toLowerCase() === 'stores' && p.Permission.toLowerCase() === 'view');
  const canCreate = roleTitle === roleTitleAdmin || permissions.some(p => p.Module.toLowerCase() === 'stores' && p.Permission.toLowerCase() === 'create');
  const canUpdate = roleTitle === roleTitleAdmin || permissions.some(p => p.Module.toLowerCase() === 'stores' && p.Permission.toLowerCase() === 'update');
 // const canDelete = roleTitle === roleTitleAdmin || permissions.some(p => p.Module.toLowerCase() === 'products' && p.Permission.toLowerCase() === 'delete');
console.log('roleTitle',roleTitle);
console.log('roleTitleAdmin',roleTitleAdmin);
console.log('permissions',permissions);
const permissions2 = useSelector(state => state) || [];
console.log('permissions state',permissions2);

  if (!canView) {
      return (  
      <div className={`${l === 'ar' ? 'page-wrapper-rtl' : 'page-wrapper'}`}><div className="content"><p>{translation?.["no_permission"] || "You do not have permission to view this page."}</p></div></div>
  )}
  //
  const route = all_routes;

  const getStoreApi = async () => {
    setLoading(true);
    const res = await APIgetStores({});
    if(res?.response?.stores){
      const storeData = res.response.stores.reverse();
      const nestData = storeData.map(item => {
        const {district, region,prefecture} = item?.locationDetails?item.locationDetails:[];
        return {
          ...item,
          district,
          region,
          prefecture
        }
      })
      setDataStore(nestData)
      setLoading(false);
    }    
  };
  
  const editStore = async (record) => {
    if(record)
    {
      console.log('record',record);
      dispatch(set_store_edit(record))
      navigate(route.addstore)
    }
    else
    {
      dispatch(set_store_edit())
      navigate(route.addstore)
    }
    
  }

  const columns = [
    {
      title: translation.name || "Name",
      dataIndex: "title",
      sorter: (a, b) => a.title.length - b.title.length,
    },
    {
      title: translation.store_code || "Store Code",
      dataIndex: "storeNumber",
      sorter: (a, b) => a.storeNumber.length - b.storeNumber.length,
    },
    {
      title: translation.city || "City",
      dataIndex: "cityId",
    },
    {
      title: translation.status || "Status",
      dataIndex: "status",
      render: (text, record) => (
          <span className="badge badge-linesuccess">
            {record.status === 0 ? "Operational" : "Permanently Closed"}
          </span>
        ),
    },
    {
      title: translation.actions || "Actions",
      dataIndex: "action",
      render: (text, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action">
            {/* <Link className="me-2 p-2" to="#">
              <Eye className="feather-view" />
            </Link> */}

            {canUpdate && (
              <Link  className="me-2 p-2" to={route.addstore} onClick={() => {
                editStore(record)
              }}>
                <Edit className="feather-edit" />
              </Link>
            )}

            {/* <Link
              className="me-2 p-2"
              to="#"
              data-bs-toggle="modal"
              data-bs-target="#add-units"
              onClick={() => editHandler(record)}
            >
              <Edit className="feather-edit" />
            </Link> */}
              {canUpdate && (
            <Link
              className="confirm-text p-2"
              to="#"
              onClick={(event) => showConfirmationAlert(event, record)}
            >
              <Trash2 className="feather-trash-2" />
            </Link>
            )}
          </div>
        </div>
      ),
      // sorter: (a, b) => a.createdby.length - b.createdby.length,
    },
  ];

  const MySwal = withReactContent(Swal);
  const showConfirmationAlert = (event, record) => {
    event.preventDefault();
    MySwal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      showCancelButton: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const res = await APIDeleteStore({ id: record._id });
          if (res) {
            await MySwal.fire("Deleted!", "Store has been deleted.", "success");
            console.log('getStoreApi test');
            await getStoreApi(); // Ensure this runs after deletion
          }
        } catch (error) {
          console.error('Deletion error:', error);
          await MySwal.fire("Error!", "An error occurred while deleting the store.", "error");
        }
      } else {
        MySwal.close();
      }
    });
  };
  
  // const showConfirmationAlert = (record) => {
  //   MySwal.fire({
  //     title: "Are you sure?",
  //     text: "You won't be able to revert this!",
  //     showCancelButton: true,
  //     confirmButtonColor: "#00ff00",
  //     confirmButtonText: "Yes, delete it!",
  //     cancelButtonColor: "#ff0000",
  //     cancelButtonText: "Cancel",
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       // Await the deletion process here
  //       APIDeleteStore({ id: record._id })
  //         .then(async (res) => {
  //           if (res) {
  //             await MySwal.fire({
  //               title: "Deleted!",
  //               text: "Store has been deleted.",
  //               confirmButtonText: "OK",
  //               customClass: {
  //                 confirmButton: "btn btn-success",
  //               },
  //             });
  //             // Now that deletion is confirmed, fetch the updated data
  //             await getStoreApi();
  //           } else {
  //             throw new Error("Deletion failed");
  //           }
  //         })
  //         .catch(async (error) => {
  //           console.log('error',error);
  //           await MySwal.fire({
  //             title: "Error!",
  //             text: "An error occurred while deleting the store.",
  //             icon: "error",
  //             confirmButtonText: "OK",
  //             customClass: {
  //               confirmButton: "btn btn-danger",
  //             },
  //           });
  //         });
  //     } else {
  //       MySwal.close();
  //     }
  //   }).catch((error) => {
  //     console.error("Error during the confirmation process:", error);
  //   });
  // };
  if (loading) {
    return (
      <div className="page-wrapper dashboard-wrapper">
        <div className="dashboard-content loader-content">
          <div id="global-loader">
            <div className="whirly-loader"></div>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className="page-wrapper">
      <div className="content">
        
        {/* <Breadcrumbs
          maintitle={translation?.["manage_stores"] || "Manage Stores"}
          subtitle={translation?.["manageyourstore"] || "Manage Your Store"}
          addButton={translation?.["addstore"] || "Add Store"}
          clicked={() => setEditStore({})}
        /> */}
        
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>{translation?.["manage_stores"] || "Manage Stores"}</h4>
              <h6>{translation?.["manageyourstore"] || "Manage Your Store"}</h6>
            </div>
          </div>
       
          {canCreate ? (
            <div className="page-btn">
              <Link to={route.addstore} className="btn btn-primary"  onClick={() => {
                editStore()
              }}>
                <PlusCircle className="me-2 iconsize" />
                {translation?.["addstore"] || "Add Store"}
              </Link>
            </div>
           ) : null}
          </div> 
        <div className="card table-list-card">
          <div className="card-body">
            {/* <div className="table-top hidden justify-content-end">
              <div className="search-set">
                <div className="search-input">
                  <input
                    type="text"
                    placeholder="Search"
                    className="form-control form-control-sm formsearch"
                  />
                  <Link to="#" className="btn btn-searchset">
                    <i data-feather="search" className="feather-search" />
                  </Link>
                </div>
              </div>
            </div> */}

            <div className="table-responsive">
              <Table
                className="table datanew"
                columns={columns}
                dataSource={dataStore}
                rowKey={(record) => record.id}
           
              />
            </div>
          </div>
        </div>
      </div>
      {/* edit={editStore} */}
      {/* <StoreModal edit={editStore} reFetchStores={getStoreApi}/> */}
    </div>
  );
};

export default StoreList;